import StorageService from "../session/storage.service";
import StorageType from "../session/storage.enum";
import AppSetting from "../../common/constants/appsetting.constant";
import axios from "axios";
import moment from "moment";
import Utilities from "../commonservice/utilities";

const DailyMessageService = {
  loggedInUserData: {},

  getLoggedInData() {
    return JSON.parse(StorageService.get('session', "userDetails"));
  },

  addDailyMessage(reqObj) {
    let loggedInUserData = this.getLoggedInData();
    let url = AppSetting.dailyMessage.addDailyMessage.replace(
      "{parentId}",
      loggedInUserData.parentId
    );
    return axios.post(url, reqObj)
      .then(res => { return res })
      .catch(err => { return err });
  },

  findDailyMessages(reqObj) {
    let loggedInUserData = this.getLoggedInData();
    let url = AppSetting.dailyMessage.findDailyMessages.replace(
      "{parentId}",
      loggedInUserData.parentId
    );
    url = `${url}${this.buildQuery(reqObj)}`;
    return axios.get(url)
      .then(res => { return res })
      .catch(err => { return err });
  },

  updateDailyMessages(reqObj, dailyMessageId) {
    let loggedInUserData = this.getLoggedInData();
    let url = AppSetting.dailyMessage.updateDailyMessages
      .replace("{parentId}", loggedInUserData.parentId)
      .replace("{dailyMessageId}", dailyMessageId);
    return axios.put(url, reqObj)
      .then(res => { return res })
      .catch(err => { return err });
  },

  getDailyMessageById(dailyMessageId) {
    let loggedInUserData = this.getLoggedInData();
    let url = AppSetting.dailyMessage.getDailyMessageById
      .replace("{parentId}", loggedInUserData.parentId)
      .replace("{dailyMessageId}", dailyMessageId);
    return axios.get(url)
      .then(res => { return res })
      .catch(err => { return err });
  },

  deleteDailyMessageById(dailyMessageId) {
    let loggedInUserData = this.getLoggedInData();
    let url = AppSetting.dailyMessage.deleteDailyMessageById
      .replace("{parentId}", loggedInUserData.parentId)
      .replace("{dailyMessageId}", dailyMessageId);
    return axios.delete(url)
      .then(res => { return res })
      .catch(err => { return err });
  },

  buildQuery(data) {
    let queryData = "";
    for (const prop in data) {
      if (
        data[prop] !== "" &&
        data[prop] !== "undefined" &&
        data[prop] !== null
      ) {
        if (queryData === "") {
          queryData = "?" + prop + "=" + data[prop];
        } else {
          queryData += "&" + prop + "=" + data[prop];
        }
      }
    }
    return queryData;
  }
}

export default DailyMessageService;